
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

momentDurationFormatSetup(moment)

export default minutes => moment.duration(minutes, 'minutes').format('D д H ч m мин')
